import { IPackageParams } from '../add-lenses-step-form';

export const getFormPackages = (products: IPackageParams[]): number => {
  return products.reduce((acc, item) => acc + Number(item.productQuantity), 0);
};
